import React, { useEffect, useState,useMemo  } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

function getParamsData(selectedSchedules, initialIndex) {
  console.log("elected", selectedSchedules);
  return {
    pesScheduleName: selectedSchedules[initialIndex].pesScheduleName,
    // pedScheduleSeq: currentState.selectedSteps?.[currentIndex]?.pedScheduleSeq || "",
    pesScheduleDescription:
      selectedSchedules[initialIndex].pesScheduleDescription,
    hiddenRecordIndicator: "A",
  };
}

const usePriceEdgeScheduleSequences = () => {
  const [data, setData] = useState([]);
  const { axios_helper_no_header } = useAxios();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isInactiveConfirmationModalOpen, setIsInactiveConfirmationModalOpen] =
    useState(false);
  const [inactiveSelectedOption, setInactiveSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const {
    ADD_PRICE_SCHEDULE,
    EDIT_PRICE_SCHEDULE,
    DISPLAY_PRICE_SCHEDULE,
    COPY_PRICE_SCHEDULE,
    PRICE_SCHEDULE_NOTE,
  } = ROUTE_PATHS;

  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);

  const {
    selectedSteps = [],
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.MAX_COPAY_SCHEDULE,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
    hideCta = false,
    paramsData: initialParamsData = {
      pesScheduleName: selectedSchedules?.[initialIndex]?.pesScheduleName,
      pedScheduleSeq:
        currentState.selectedSchedules?.[initialIndex]?.pedScheduleSeq || "",
      pesScheduleDescription:
        selectedSchedules?.[initialIndex]?.pesScheduleDescription,
      hiddenRecordIndicator: "A",
    },
    type = "",
  } = currentState;
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [externalMode, setExternalMode] = useState(initialExternalMode);

  const [paramsData, setParamsData] = useState(initialParamsData);

  const screen_title = "Price Edge Schedule Sequences";
  const screenNumber = "RCPED001";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "PES Schedule Name",
      name: "pesScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "PES Schedule Description",
      name: "pesScheduleDescription",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "PED Schedule Seq",
      name: "pedScheduleSeq",
      label: "Sequence",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 3,
    },
    {
      fieldLabel: "Hidden Records Indicator*Inactive",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      maxLength: 20,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Records Indicator", condition: "*Inactive" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = externalMode  || hideCta
  ? [  
      {  
        button_label: "Export as CSV",  
        button_handeler: () => {  
          exportAsCSV();  
        },  
        button_key: "",  
      },  
    ]  
  : [  
      {  
        button_label: "Add Price Edge Schedule Sequence",  
        button_handeler: () => {  
          navigateToPage(ROUTE_PATHS.ADD_PRICE_EDGE_SCHEDULE_SEQUENCE, [  
            ...previousState,  
            { ...currentState, paramsData: paramsData, currentIndex },  
            {  
              selectedSteps: selectedRows.length ? selectedRows : [rowData],  
              selectedSchedules: [selectedSchedules[currentIndex]],  
              previousScreen: location.pathname,  
              currentIndex: 0,  
            },  
          ]);  
        },  
        button_key: "F6",  
      },  
      {  
        button_label: "Export as CSV",  
        button_handeler: () => {  
          exportAsCSV();  
        },  
        button_key: "",  
      },  
    ];  

  /* Gear Icon Menu option CTAs */

  const menuOptions = externalMode || hideCta
  ? [  
      {  
        label: "Display",  
        icon: <span className="material-icons">visibility</span>,  
        command: () => {  
          const selectedSteps = selectedRows.length ? selectedRows : [rowData];  
          const updatedParamsData = getUpdatedParamsData(selectedSteps, {  
            ...paramsData,  
          });  
          if (updatedParamsData.hiddenRecordIndicator === undefined) {  
            updatedParamsData.hiddenRecordIndicator = 'A';  
          }
          navigateToPage(ROUTE_PATHS.DISPLAY_PRICE_EDGE_SCHEDULE_SEQUENCE, [  
            ...previousState,  
            { ...currentState, currentIndex, paramsData: updatedParamsData,externalMode },  
            {  
              selectedSteps: selectedRows.length ? selectedRows : [rowData],  
              selectedSchedules: [selectedSchedules[currentIndex]],  
              previousScreen: location.pathname,  
              currentIndex: 0,  
              externalMode: true,
            },  
          ]); 
        },  
      },  
    ]  
  : [  
      {  
        label: "Edit",  
        icon: <span className="material-icons">edit</span>,  
        command: () => {  
          editValidation();  
        },  
      },  
      {  
        label: "Inactivate",  
        icon: <span className="material-icons">block</span>,  
        command: () => {  
          openInactiveConfirmationModal();  
        },  
      },  
      {  
        label: "Display",  
        icon: <span className="material-icons">visibility</span>,  
        command: () => {  
          const selectedSteps = selectedRows.length ? selectedRows : [rowData];  
          const updatedParamsData = getUpdatedParamsData(selectedSteps, {  
            ...paramsData,  
          });  
          navigateToPage(ROUTE_PATHS.DISPLAY_PRICE_EDGE_SCHEDULE_SEQUENCE, [  
            ...previousState,  
            { ...currentState, currentIndex, paramsData: updatedParamsData },  
            {  
              selectedSteps: selectedRows.length ? selectedRows : [rowData],  
              selectedSchedules: [selectedSchedules[currentIndex]],  
              previousScreen: location.pathname,  
              currentIndex: 0,  
            },  
          ]);  
        },  
      },  
    ];  

  /* Data table column info. */
  const columnDef = [
    {
      header: "Sequence",
      field: "pedScheduleSeq",
    },
    {
      header: "Network",
      field: "pedPharmacySuperNetwork",
    },
    {
      header: "MAC List",
      field: "pedMacList",
    },
    {
      header: "Rate Percent",
      field: "pedRate",
    },
    {
      header: "Type",
      field: "pedType",
    },
    {
      header: "From Date",
      field: "pedFromDate",
    },
    {
      header: "Thru Date",
      field: "pedThroughDate",
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "pedCounter";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    const { pesScheduleName, pedScheduleSeq, hiddenRecordIndicator } =
      paramsData;
    const params = {
      pesScheduleName: pesScheduleName,
      pedScheduleSeq: pedScheduleSeq,
      hiddenRecordIndicator: hiddenRecordIndicator,
      page: page,
      size: rows,
    };

    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/pedPriceEdgeSchDtl`,
        null,
        params
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    if (currentIndex !== initialIndex) {
      const { pesScheduleName = "", pesScheduleDescription = "" } =
        selectedSchedules?.[currentIndex];
      const { pedScheduleSeq = "" } =
        currentState?.selectedSteps?.[currentIndex] || {};
      setParamsData({
        pesScheduleName,
        pedScheduleSeq,
        pesScheduleDescription,
        hiddenRecordIndicator: "A",
      });
    }
  }, [selectedSchedules, currentIndex, currentState?.selectedSteps]);


  useEffect(() => {
    if (!selectedSchedules?.[currentIndex]?.pesScheduleName) return;
    fetchData();
  }, [paramsData, rows, currentPage, selectedOption, selectedSchedules]);

  useEffect(() => {
    if (currentIndex !== initialIndex)
      setParamsData(getParamsData(selectedSchedules, currentIndex));
  }, [currentIndex, initialIndex]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (externalMode) {
          const message = {
            message: "navigate-to-external-program",
            url: previousScreen,
            parameters: {
              state: [...previousState],
            },
          };
          console.log("back messages", message);
          window.parent.postMessage(message, "*");
        }
        else if (currentIndex < selectedSchedules.length - 1) {
          setCurrentIndex(currentIndex + 1);
        } else {
          // navigateToPage(location.pathname.includes(ROUTE_PATHS.PRICE_EDGE_SCHEDULE_SEQUENCE) ? ROUTE_PATHS.PRICE_EDGE_SCHEDULE: previousScreen, previousState);
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = { prcPriceScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/priceschedule", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const { pesScheduleName, pedScheduleSeq, hiddenRecordIndicator } =
      paramsData;
    const params = {
      pesScheduleName: pesScheduleName,
      pedScheduleSeq: pedScheduleSeq || "",
      hiddenRecordIndicator: hiddenRecordIndicator || "A",
    };
    const queryParams = new URLSearchParams({ ...params });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/pedPriceEdgeSchDtl/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "set-params") {
      const { currentIndex = 0, selectedSchedules = []} = data[data.length - 1] || {};
      setStateVal(data);
      setExternalMode(true);
      if (selectedSchedules.length) {
        setParamsData({
          pesScheduleName: selectedSchedules?.[currentIndex]?.pesScheduleName,
          pedScheduleSeq: selectedSchedules?.[currentIndex]?.pedScheduleSeq,
          pesScheduleDescription: selectedSchedules?.[currentIndex]?.pesScheduleDescription,
        });
      }
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  const openInactiveConfirmationModal = () => {
    setIsInactiveConfirmationModalOpen(true);
  };

  const closeInactiveConfirmationModal = () => {
    console.log(inactiveSelectedOption);
    setIsInactiveConfirmationModalOpen(false);
    setInactiveSelectedOption("no");
  };

    const inactivateRecord = () => {
      if (inactiveSelectedOption === "yes") {
        const { pesScheduleName, pedScheduleSeq, pedSeq } = rowData;
        let payload = [{ pesScheduleName, pedScheduleSeq, pedSeq }];
        const params = {
          screenNumber,
        };

        if (selectedRows?.length > 1) {
          payload = selectedRows?.map((item) => ({
            pesScheduleName: item?.pesScheduleName,
            pedScheduleSeq: item?.pedScheduleSeq,
            pedSeq: item?.pedSeq,
          }));
        }

        axios_helper_no_header(
          "PUT",
          "api/pedPriceEdgeSchDtl/inactivatePedPriceEdgeSchDtl",
          payload,
          params
        )
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "",
              detail: response.responseStatus.message,
              life: 3000,
            });
            closeInactiveConfirmationModal();
          })
          .catch((error) => {
            console.error("There was an error inactivating the data!", error);
            const {
              responseStatus: { displayErrorFields = null, message } = {},
            } = error.data;
            toast.current.show({
              severity: "error",
              summary: "",
              detail: message,
              life: 3000,
            });
            closeInactiveConfirmationModal();
          }).finally(() => {
            fetchData();
          });
      } else {
        closeInactiveConfirmationModal();
      }
    };

  const getUpdatedParamsData = (schedules, existingParamsData) => {
    const lastScheduleSeq = schedules[schedules.length - 1]?.pedScheduleSeq;
    const updatedParamsData = {
      ...existingParamsData,
      pedScheduleSeq: lastScheduleSeq,
    };
    return updatedParamsData;
  };

  const editValidation = async () => {
    const selectedRecords = selectedRows.length ? selectedRows : [rowData];
    const params = selectedRecords.map((record, i) => {
      const { pesScheduleName, pedScheduleSeq, pedSeq } = record;
      return { pesScheduleName, pedScheduleSeq, pedSeq };
    });

    try {
      const { responseData } = await axios_helper_no_header(
        "POST",
        "api/pedPriceEdgeSchDtl/filterActiveRecords",
        params
      );
      if (responseData.length) {
        const hasInactiveRecords =
          responseData.length < selectedRecords.length ? true : false;
        const activeRecords = selectedRecords.filter((selected) =>
          responseData.some(
            (active) =>
              active.pesScheduleName === selected.pesScheduleName &&
              active.pedScheduleSeq === selected.pedScheduleSeq &&
              active.pedSeq === selected.pedSeq
          )
        );
        const updatedParamsData = getUpdatedParamsData(activeRecords, {
          ...paramsData,
        });
        navigateToPage(ROUTE_PATHS.EDIT_PRICE_EDGE_SCHEDULE_SEQUENCE, [
          ...previousState,
          { ...currentState, currentIndex, paramsData: updatedParamsData },
          {
            selectedSteps: activeRecords,
            selectedSchedules: [selectedSchedules[currentIndex]],
            previousScreen: location.pathname,
            currentIndex: 0,
            hasInactiveRecords,
          },
        ]);
      } else {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: "Cannot edit inactive record.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("There was an error editing the data!", error);
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      toast.current.show({
        severity: "error",
        summary: "",
        detail: message,
        life: 3000,
      });
    }

    //const { pesScheduleName, pedScheduleSeq, pedSeq } = rowData
    //  const params = { pesScheduleName: pesScheduleName, pedScheduleSeq: pedScheduleSeq, pedSeq: pedSeq, };
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
    inactivateRecord,
    isInactiveConfirmationModalOpen,
    closeInactiveConfirmationModal,
    setInactiveSelectedOption,
  };
};

export default usePriceEdgeScheduleSequences;